export const BINDER_LIST_GET = "common/BinderList/BINDER_LIST_GET";
export const BINDER_ITEM_GET = "common/BinderList/BINDER_ITEM_GET";
export const CHECKED_TOGGLE = "common/BinderList/CHECKED_TOGGLE";
